module.exports = __webpack_public_path__ + "assets/jinpai.333a78f4.svg";